import { render } from "./video-desc-skeleton.vue?vue&type=template&id=4c1c2430&scoped=true"
import script from "./video-desc-skeleton.vue?vue&type=script&lang=js"
export * from "./video-desc-skeleton.vue?vue&type=script&lang=js"

import "./video-desc-skeleton.vue?vue&type=style&index=0&id=4c1c2430&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1c2430"]])

export default __exports__